import { CoreInterfaces, DTOs } from "src/core/Models";

export const InterimListedCompaniesProcessor: CoreInterfaces.QuestionProcessors =
  (appState: CoreInterfaces.AppState, serviceDTO: DTOs.ServiceDTO) => {
    return {};
  };
